mutation updateUser($input: UpdateUserInput!) {
  user: updateUser(input: $input) {
    id
  }
}
